const getters = {
  // device: state => state.system.app.device,
  // theme: state => state.system.app.theme,
  // color: state => state.system.app.color,
  // token: state => state.system.user.token,
  // avatar: state => state.system.user.avatar,
  // nickname: state => state.system.user.name,
  // welcome: state => state.system.user.welcome,
  // roles: state => state.system.user.roles,
  // userInfo: state => state.system.user.info,
  // addRouters: state => state.system.permission.addRouters,
  multiTab: state => state.system.app.multiTab,
  // lang: state => state.system.i18n.lang,
};

export default getters;
